import { Component, Input } from "@angular/core";
import { ISimpleTransaction } from "./models/interfaces/simple-transaction.interfaces";
import { CommonModule } from "@angular/common";
import { ComponentsModule } from "@shared/components/components.module";
import { StaticServeModule } from "@core/static-serve/static-serve.module";

@Component({
    selector: "mdk-simple-transaction-item",
    templateUrl: './simple-transaciton-tiem.component.html',
    styleUrls: [
        './styles/simple-transaction-item.mobile.scss',
    ],
    standalone: true,
    imports: [
        CommonModule,
        ComponentsModule,
        StaticServeModule,
    ]
})
export class SimpleTransactionItemComponent {
    @Input() transaction: ISimpleTransaction
}